module.exports = __webpack_public_path__ + "static/media/cookie2-angle.2e024b2c.png";